var $fb = $;

$fb(function () {

  // Sync the visible dmdFancyBox image to the currently selected variant
  function syncThumbFromVariant() {
    var $selected = $fb('.product-gallery--media[data-gallery-selected=true]');
    if (!$selected.length) return;
    var selectedIndex = parseInt($selected.attr('data-gallery-index'), 10);
    var $dmdImgs = $fb('.dmdFancyBoxImgs');
    if (selectedIndex >= 0 && selectedIndex < $dmdImgs.length) {
      $dmdImgs.hide();
      $dmdImgs.eq(selectedIndex).show();
    }
  }

  // Sync the visible dmdFancyBox thumbnail to whatever slide is currently shown in Fancybox
  function syncThumbFromFancybox() {
    var currentImg = document.querySelector('.fancybox-slide--current img');
    if (currentImg && currentImg.src) {
      // Update whichever anchor is currently displayed, NOT a hardcoded
      // :first-child. On explosive pages (and standard pages where a non-first
      // variant is selected) syncThumbFromVariant shows a different anchor via
      // hide()/show(), so :first-child is hidden and updating it does nothing
      // visible — the main image would not switch on close.
      var $imgs = $fb('.dmdFancyBoxImgs');
      var $visible = $imgs.filter(function () {
        return $fb(this).css('display') !== 'none';
      }).first();
      if (!$visible.length) $visible = $imgs.first();
      $visible.find('img').attr('src', currentImg.src);
    }
  }

  syncThumbFromVariant();

  $fb('.options-selection__option-value-input').on('change', function () {
    if ($fb(this).is(':checked')) setTimeout(syncThumbFromVariant, 500);
  });

  $fb(document).on('click', 'button.custom_gallery_image', function () {
    setTimeout(syncThumbFromVariant, 500);
  });

  // Use a MutationObserver (jQuery-independent) to detect slide changes inside Fancybox
  // and keep the main thumbnail in sync with the active slide.
  var fbSlideObserver = null;

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];

      for (var j = 0; j < m.addedNodes.length; j++) {
        var added = m.addedNodes[j];
        if (added.nodeType === 1 && added.classList.contains('fancybox-container')) {
          fbSlideObserver = new MutationObserver(syncThumbFromFancybox);
          fbSlideObserver.observe(added, { subtree: true, attributes: true, attributeFilter: ['class'] });
        }
      }

      for (var k = 0; k < m.removedNodes.length; k++) {
        var removed = m.removedNodes[k];
        if (removed.nodeType === 1 && removed.classList.contains('fancybox-container')) {
          if (fbSlideObserver) {
            fbSlideObserver.disconnect();
            fbSlideObserver = null;
          }
        }
      }
    }
  }).observe(document.body, { childList: true });

  // Fancybox thumbnail strip: Space should select the thumbnail, same as clicking it.
  $fb(document).on('keydown', '.fancybox-thumbs__list a', function (e) {
    if (e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      this.click();
    }
  });

  // Standard/explosive: Space on the focused anchor should open Fancybox, not scroll the page.
  $fb(document).on('keydown', '.dmdFancyBoxImgs', function (e) {
    if (e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      $fb(this).closest('.dmdFancyBox').trigger('click');
    }
  });

  // Grid/PhotoSwipe: show a focus ring on the active figure when focused via keyboard.
  // Done via JS+setProperty('important') to guarantee visibility regardless of
  // cascade or parent overflow clipping the CSS outline.
  $fb(document).on('focus', '[data-gallery-figure][tabindex="0"]', function () {
    this.style.setProperty('box-shadow', 'inset 0 0 0 2px #005fcc', 'important');
  }).on('blur', '[data-gallery-figure][tabindex="0"]', function () {
    this.style.removeProperty('box-shadow');
  });

  // Grid/PhotoSwipe: Space or Enter on the focused figure triggers the expand button.
  $fb(document).on('keydown', '[data-gallery-figure][tabindex="0"]', function (e) {
    if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
      e.preventDefault();
      $fb('[data-gallery-expand]').trigger('click');
    }
  });

  // Open Fancybox at the correct index by triggering a native DOM click on the
  // matching <a>, using the gallery index of the selected Empire figure.
  var _opening = false;

  $fb('.dmdFancyBox').on('click', function (e) {
    if (_opening) return;
    e.preventDefault();
    e.stopPropagation();

    var $selectedFigure = $fb('.product-gallery--media[data-gallery-selected=true]');
    var selectedIndex = $selectedFigure.length ? parseInt($selectedFigure.attr('data-gallery-index'), 10) : 0;
    var items = $fb('.dmdFancyBoxImgs').toArray();
    var target = items[selectedIndex] || items[0];

    _opening = true;
    target.click();
    _opening = false;
  });

});
